import { gtmEventShareLink } from '../utils/analytics';
import { URL_CONFIG_GET_PARAM } from '../utils/constants';

export const copyLink = (userData, successMessage) => {
	const url = new URL(window.location);
	url.searchParams.set(URL_CONFIG_GET_PARAM, JSON.stringify(userData));
	navigator.clipboard.writeText(url.href);

	gtmEventShareLink();

	// Show the toast
	window.showToast?.(successMessage, 'success');
};
